import bankUsersReducer from '../state/bank-users-slice'

export const bankUsersReducers = {
  bankUsers: bankUsersReducer
}
